import { useEffect, useRef } from "react";

export const useFocus = <T extends HTMLElement = HTMLInputElement>(): [React.RefObject<T | null>, () => void] => {
	const ref = useRef<T>(null);
	const focus = () => { setTimeout(() => ref.current && ref.current.focus(), 1); };
	return [ref, focus];
};

export const useFocusOnLoad = <T extends HTMLElement = HTMLInputElement>(): React.RefObject<T | null> => {
	const [ref, focus] = useFocus<T>();
	useEffect(focus, [focus]);

	return ref;
};
